import { useState } from 'react';
import { FormControl, Stack, FormLabel, Text, Box } from '@chakra-ui/react';
import { Field } from 'formik';
import DropDown from '@/components/forms/new/formikFormFields/DropDown';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
    descriptionStyling,
} from 'components/forms/new/formStyles';
import { FORM_FIELD_PATHS } from '../constants.js';
import { useCustomSIPHeaderForm } from '../hooks/useCustomSIPHeaderForm.js';
import useGetCustomSIPHeaderOptions from '../queries/useGetCustomSIPHeaderOptions.jsx';

const CustomSIPHeaderType = ({ darkMode, errors, touched }) => {
    const [isHovered, setIsHovered] = useState(false);
    const { updateFormData } = useCustomSIPHeaderForm();
    const { data: optionsData, isLoading: isLoadingOptions } =
        useGetCustomSIPHeaderOptions();

    const typeOptions =
        optionsData?.customHeaderTypes?.map((type) => ({
            id: type,
            name: type,
        })) || [];

    const handleSelectChange = (item) => {
        updateFormData(FORM_FIELD_PATHS.CUSTOM_HEADER_TYPE_ID, item?.id || '');
    };

    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={
                !!errors[FORM_FIELD_PATHS.CUSTOM_HEADER_TYPE_ID] &&
                touched[FORM_FIELD_PATHS.CUSTOM_HEADER_TYPE_ID]
            }
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={stackStyling(true)}>
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Type <span style={{ color: '#e53e3e' }}>*</span>
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        Select TCAP entity to apply header to. All calls
                        associated with this entity shall have the header
                        applied.
                    </Text>
                </Box>
                <Field
                    component={DropDown}
                    name={FORM_FIELD_PATHS.CUSTOM_HEADER_TYPE_ID}
                    data={typeOptions}
                    shownValue="name"
                    width="100%"
                    handleSelectChange={handleSelectChange}
                    placeholder={
                        isLoadingOptions
                            ? 'Loading types...'
                            : 'Select entity type'
                    }
                    isDisabled={isLoadingOptions}
                    darkMode={darkMode}
                    noPadding={false}
                />
                {isHovered && (
                    <FieldToolTip
                        label="Select the entity type for this header"
                        ariaLabel="custom-sip-header-type-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default CustomSIPHeaderType;
